import React from "react";
import { Button, Space, Typography } from "antd";

const { Text } = Typography;

const VideoTypeFilters = ({ selectedTypes, onTypesChange }) => {
    const toggleType = (type) => {
        if (selectedTypes.includes(type)) {
            onTypesChange(selectedTypes.filter((item) => item !== type));
            return;
        }
        onTypesChange([...selectedTypes, type]);
    };

    return (
        <div className="content-filter-panel">
            <Text className="content-filter-panel__label">Video Type</Text>
            <Space wrap className="content-filter-panel__button-list">
                <Button
                    size="small"
                    className={`content-filter-panel__type-button ${selectedTypes.includes("youtube") ? "content-filter-panel__type-button--active" : ""}`}
                    onClick={() => toggleType("youtube")}>
                    YouTube
                </Button>
                <Button
                    size="small"
                    className={`content-filter-panel__type-button ${selectedTypes.includes("vimeo") ? "content-filter-panel__type-button--active" : ""}`}
                    onClick={() => toggleType("vimeo")}>
                    Vimeo
                </Button>
            </Space>
        </div>
    );
};

export default VideoTypeFilters;
